import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'ACCESS_OPER',
  title: 'Come posso dare accesso a un\'operazione ai miei collaboratori?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Fare clic sulla scheda «Operazioni»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCESS_OPER/IT_ACCESS_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sull\'operazione di tua scelta'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCESS_OPER/IT_ACCESS_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Clicca in alto a destra sui 3 punti'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCESS_OPER/IT_ACCESS_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Fare clic su «Dare accesso a questa operazione»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCESS_OPER/IT_ACCESS_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Selezionare gli utenti e quindi confermare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCESS_OPER/IT_ACCESS_OPER_5.png`
  }]
};
